<template>
    <div class="card bg-dark-white">
        <div class="card-body p-4">
            <div class="row align-items-center">
                <div class="col-lg-3 col-12 mb-3">
                    <div class="h3 mb-0">Ajout rapide de produit par référence</div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6 mb-3">
                    <search-product :placeholder="placeholder"></search-product>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-6 mb-3 text-center">
                    <div class="form-group--number product__qty">
                        <button class="up">+</button>
                        <button class="down">-</button>
                        <input type="number" class="form-control qty-input" min="1" value="3" title="Qté" name="qty">
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 col-12 mb-3">
                    <button class="ps-btn ps-btn--md ps-btn--outline w-100"><i class="fa fa-cart-plus"></i> Ajouter le produit</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import SearchProduct from "./partials/SearchProduct";

export default {
    data: function() {
        return {}
    },
    props: {
        route: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
        }
    },
    components: {
        SearchProduct
    },
}
</script>